





















































































import _ from 'lodash';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';
import {
    ActionError as campaignStoreErr,
    CurrentCampaignType,
} from '@/store/campaign/types';
import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SetAdset as feedbackTerms } from '@/const/terms/feedback/adset';
import { SettingConfirm as confirmTerms} from '@/const/terms/feedback/confirm';
import { SetCampaign as campaignFeedback} from '@/const/terms/feedback/campaign';


import { STATUS } from '@/const/status/index';
import { DATE_TYPE, ID_TYPE } from '@/const/types';
import { TableOptionType, DefaultOption } from '@/const/options/DefaultTableOption';
import {
    SearchFormType,
    AdsetSummaryType,
    IAdsetSummary,
    IAdsetBrief,
    AdsetResponse,
} from './types';

import { RawLocation } from 'vue-router';
import { AxiosError, AxiosResponse } from 'axios';

import DateRangePicker from '@/components/ElementComponent/Date/DateRangePicker.vue';
import Select from '@/components/ElementComponent/Select/index.vue';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';
import ExplainColumn from '@/components/ElementComponent/Column/ExplainColumn.vue';
import NameColumn from '@/components/ElementComponent/Column/NameColumn.vue';
import PriceColumn from '@/components/ElementComponent/Column/PriceColumn.vue';

import { CampaignInfoResponse } from '../editingTypes';

const campaignModule = namespace('Campaign');

@Component<Adset>({
    name: 'Adset',
    components: {
        DateRangePicker,
        Select,
        NumberColumn,
        DateColumn,
        StatusColumn,
        SelectAllColumn,
        ExplainColumn,
        NameColumn,
        PriceColumn,
    },
})
export default class Adset extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;
    private confirmTerms = confirmTerms;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private deleteConfirmVisible: boolean = false;

    private filterForm: SearchFormType = { status: STATUS.ALL, query: '', page: 1, totalPages: 0, sort: null };
    private statusOptions: { value: STATUS; label: string; }[] = [
        { value: STATUS.ALL, label: '모든 상태' },
        { value: STATUS.ACTIVE, label: '활성' },
        { value: STATUS.INACTIVE, label: '비활성' },
    ];
    private appOptions: { value: string; label: string }[] = [];
    private dateValue: DATE_TYPE[] = [new Date(), new Date()];
    private tableData: AdsetSummaryType = [];
    private selectedAdset: AdsetSummaryType = [];

    @campaignModule.State('currentCampaign') private currentCampaign!: CurrentCampaignType;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign!: any;
    @campaignModule.Action('SET_CURRENT_ADSET') private setCurrentAdset: any;

    get date() {
        return [
            moment(this.dateValue[0]).format('YYYYMMDDHH'),
            moment(this.dateValue[1]).format('YYYYMMDDHH'),
        ];
    }
    private refreshDate(v: Date[]) {
        if (v) {
            this.getAdsetResponseHandler();
        }
    }
    private sortChangeHandler({column, prop, order}: {column: any, prop: string, order: string}) {        
        this.filterForm.sort = prop ? {prop: prop, order: order} : null;
        this.getAdsetResponseHandler();
    }
    private handleSelectionChange(val: AdsetSummaryType) {
        this.selectedAdset = val;
    }
    private async setCurrentAdsetHandler(scope: any, to: RawLocation, isCtrlPressed: boolean) {
        try {
            await this.setCurrentAdset({
                idList: scope.row.idList,
                name: scope.row.name,
            });
            (to as any).params.adsetGroup = (to as any).params.adsetGroup;
            
            if (isCtrlPressed) {
                const routerData =this.$router.resolve(to);
                window.open(routerData.href, '_blank');
            } else {
                this.$router.push(to);
            }
        } catch (err) {
            switch (err.type) {
                case campaignStoreErr.SET_CURRENT_ADSET:
                    this.$notify.error(feedbackTerms.currentAdset.error.fail);
                    break;
            }
            throw err;
        }
    }
    private handleCommand(command: string) {
        switch (command) {
            case 'delete': break;
            case 'active':
                this.changeStatus(this.selectedAdset, true, true);
                break;
            case 'inactive':
                this.changeStatus(this.selectedAdset, false, true);
                break;
        }
    }
    private copyAdset(adset: IAdsetSummary) {
        this.loading = true;
        this.$http.adserverAPI.post('CopyAdset', {
            adset_ids: adset.idList,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.copyAdset.success);
                    this.getAdsetResponseHandler();
                    return ;
                }
                throw new Error(feedbackTerms.copyAdset.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.copyAdset.error.fail);
                } else {    
                    this.$notify.error(err.message);
                }
                this.loading = false
                throw err;
            })
    }
    private deleteAdsets() {
        this.deleteConfirmVisible = false;
        const targetIDs = this.selectedAdset.reduce((pre: ID_TYPE[], item: IAdsetSummary) => {
            return [...pre, ...(item.idList as ID_TYPE[])];
        }, []);
        if (targetIDs.length === 0) return true;
        this.loading = true;
        this.$http.adserverAPI.post('deleteAdset', {
            adset_ids: targetIDs,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.deleteAdset.success);
                    this.getAdsetResponseHandler();
                    return true;
                }
                throw new Error(feedbackTerms.deleteAdset.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.deleteAdset.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                this.loading = false;
                throw err;
            })
    }
    private changeStatus(adsets: IAdsetSummary[],  is_use: boolean | null = null, fromTools: boolean = false ) {
        if (adsets.length === 0) return false;
        const adset_ids = adsets.reduce((pre: ID_TYPE[], item: IAdsetSummary) => [...pre, ...(item.idList as ID_TYPE[])] as ID_TYPE[], []);
        let toStatus: boolean = ((adsets[0].status as STATUS) & 1) === (fromTools ?  STATUS.ACTIVE : STATUS.INACTIVE);
        if (is_use !== null ) toStatus = is_use;
        let statusBackup: STATUS[] = [];

        adsets.forEach((item: IAdsetSummary) => {
            const s = item.status as STATUS;
            if (fromTools) statusBackup.push(s);
            else statusBackup.push(((s & ~1) | ((s & 1) ^ 1)));
            item.status = (s & ~1) | (toStatus ? STATUS.ACTIVE : STATUS.INACTIVE);
            this.$nextTick(() => {
                item.disabled = true;
            });
        })
        statusBackup = statusBackup.reverse();
        this.$http.adserverAPI.post('UpdateAdsetStatus', {
            adset_ids: adset_ids,
            is_use: toStatus,
        })
            .then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.changeStatus.success);
                    return true;
                }
                throw new Error(feedbackTerms.changeStatus.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.changeStatus.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                adsets.forEach((item: IAdsetSummary) => {
                    const s = statusBackup.pop() as STATUS;
                    item.status = s;
                })
                throw err;
            })
            .finally(() => {
                this.loading = false;
                adsets.forEach((item: IAdsetSummary) => {
                    item.disabled = false;
                })
            })
    }
    private getAdsetResponseHandler() {
        this.loading = true;
        this.selectedAdset = [];
        this.getAdsetResponse().then((res: any) => res.data)
            .then((data: AdsetResponse) => {
                data.adsets.forEach((item: IAdsetSummary) => {
                    item.status = STATUS.INACTIVE;
                    item.idList = [];
                    item.targets.forEach((adset: IAdsetBrief) => {
                        (item.idList as ID_TYPE[]).push(adset.adset_id);
                        (item.status as STATUS) |= adset.status;
                    })
                });
                this.tableData = data.adsets
                this.filterForm.totalPages = data.pages;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
            })
    }
    private getAdsetResponse(){
        this.setRouteQueryFromFilter();
        const sort = this.filterForm.sort && this.filterForm.sort.prop ? `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}` : '';
        return this.$http.adserverAPI.post('GetAdsetReport', {
            campaign_id: this.currentCampaign.id,
            placements: ['1', '2', '3', '4', '5', '6'],
            since: this.date[0],
            until: this.date[1],
            status: this.filterForm.status,
            query: this.filterForm.query,
            page: this.filterForm.page,
            sort: sort,
        })
    }
   
    private setRouteQueryFromFilter(){
        const query: {[name: string]: any} = {
            since: (this.dateValue[0] as Date).getTime(),
            until: (this.dateValue[1] as Date).getTime(),
        }
        this.filterForm.status !== undefined && (query.status = this.filterForm.status);
        this.filterForm.query && (query.query = this.filterForm.query);
        this.filterForm.page && (query.page = this.filterForm.page);
        this.filterForm.sort && this.filterForm.sort.prop && this.filterForm.sort.order && (query.sort = `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}`);

        const newQuery = Object.entries(query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: encodeURIComponent(value)};
        }, {});
        
        if (!(_.isEqual(newQuery, this.$route.query))) {
            this.$router.replace({
                ...this.$route,
                query: newQuery,
            })
        }
    }
    private setRouteQueryToFilter() {
        const query = Object.entries(this.$route.query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: decodeURIComponent(value)};
        }, {}) as any;
        query.since !== undefined && (this.dateValue[0] = new Date(Number.parseInt(query.since as string)));
        query.until !== undefined && (this.dateValue[1] = new Date(Number.parseInt(query.until as string)));
        this.dateValue = [this.dateValue[0], this.dateValue[1]];
        
        query.status !== undefined && (this.filterForm.status = Number.parseInt(query.status as string) as STATUS);
        query.query !== undefined && (this.filterForm.query = query.query as string);
        query.page !== undefined && (this.filterForm.page = Number.parseInt((query.page as string)));
        query.sort !== undefined && (this.filterForm.sort = (query.sort as string)[0] === '-' ? { 
            order: 'descending', prop: (query.sort as string).slice(1)
        } : {
            order: 'ascending', prop: (query.sort as string)
        });
    }
    private async created() {
        if (this.currentCampaign.id !== this.$route.params.campaignID) {
            const campaignID = this.$route.params.campaignID;
            this.loading = true;
            await this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID}).then((res: any) => res.data)
                .then(async (data: CampaignInfoResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(campaignFeedback.getResponse.error.notFound);
                    }
                    try {
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app: data.app,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(campaignFeedback.getResponse.error.setCurrentCampaign);
                                break;
                        }
                        throw new Error(campaignFeedback.getResponse.error.fail);
                    }
                })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(campaignFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'campaign'});
                    }
                    throw err;
                })
                .finally(() => {
                    this.loading = false;
                })
        }

        this.setRouteQueryToFilter();
        this.getAdsetResponseHandler();
    }
}

